var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The entry point for highlighting!
 *
 * Given a content node and a set of serialized highlights, this component
 * renders the content with the given highlights applied. The content's DOM is
 * not modified by this process, so any content should be safe to pass to this
 * component.
 *
 * This component also renders controls for the user to add/remove/update
 * highlights. When the user does so, this component will update the full set
 * of highlights, serialize them, and call `onSerializedHighlightsUpdate` with
 * new set of serialized highlights, which you can then persist and send back
 * down to this component. Easy peasy!
 */
var React = require("react");

var _require = require("aphrodite"),
    StyleSheet = _require.StyleSheet,
    css = _require.css;

var HighlightingUI = require("./ui/highlighting-ui.jsx");
var WordIndexer = require("./word-indexer.jsx");

var _require2 = require("./highlights.js"),
    addHighlight = _require2.addHighlight,
    buildHighlight = _require2.buildHighlight,
    deserializeHighlight = _require2.deserializeHighlight,
    serializeHighlight = _require2.serializeHighlight;

var babelPluginFlowReactPropTypes_proptype_DOMRange = require("./types.js").babelPluginFlowReactPropTypes_proptype_DOMRange || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_SerializedHighlightSet = require("./types.js").babelPluginFlowReactPropTypes_proptype_SerializedHighlightSet || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_DOMHighlightSet = require("./types.js").babelPluginFlowReactPropTypes_proptype_DOMHighlightSet || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_DOMHighlight = require("./types.js").babelPluginFlowReactPropTypes_proptype_DOMHighlight || require("react").PropTypes.any;

var HighlightableContent = function (_React$PureComponent) {
    _inherits(HighlightableContent, _React$PureComponent);

    function HighlightableContent() {
        var _temp, _this, _ret;

        _classCallCheck(this, HighlightableContent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            wordRanges: []
        }, _this._handleAddHighlight = function (highlight) {
            var newDomHighlights = addHighlight(_this._getDOMHighlights(), highlight);

            var newSerializedHighlights = {};
            for (var _iterator = Object.keys(newDomHighlights), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var key = _ref;

                newSerializedHighlights[key] = serializeHighlight(newDomHighlights[key]);
            }

            _this.props.onSerializedHighlightsUpdate(newSerializedHighlights);
        }, _this._handleRemoveHighlight = function (keyToRemove) {
            var serializedHighlights = _this.props.serializedHighlights;

            var newSerializedHighlights = _extends({}, serializedHighlights);
            delete newSerializedHighlights[keyToRemove];
            _this.props.onSerializedHighlightsUpdate(newSerializedHighlights);
        }, _this._handleWordsUpdate = function (wordRanges) {
            _this.setState({ wordRanges: wordRanges });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    // References to the mounted container and content divs.


    HighlightableContent.prototype._buildHighlight = function _buildHighlight(highlightRange) {
        // TODO(mdr): If _buildHighlight starts getting called more often, we
        //     might want to cache the DOMHighlightSet instead of recomputing
        //     it here.
        return buildHighlight(this._getDOMHighlights(), this.state.wordRanges, highlightRange);
    };

    /**
     * Take the highlights from props, and deserialize them into DOMHighlights,
     * according to the latest cache of word ranges.
     */


    HighlightableContent.prototype._getDOMHighlights = function _getDOMHighlights() {
        var serializedHighlights = this.props.serializedHighlights;
        var wordRanges = this.state.wordRanges;


        var domHighlights = {};
        for (var _iterator2 = Object.keys(serializedHighlights), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var key = _ref2;

            domHighlights[key] = deserializeHighlight(serializedHighlights[key], wordRanges);
        }
        return domHighlights;
    };

    /**
     * Add the given DOMHighlight to the current set.
     */


    /**
     * Remove the given highlight from the list, and call our callback with the
     * new set of highlights.
     */


    /**
     * When our WordIndexer sends us a new cache of word ranges, store it in
     * our component state.
     */


    HighlightableContent.prototype.render = function render() {
        var _this2 = this;

        var highlights = this._getDOMHighlights();

        // NOTE(mdr): This lambda is rebuilt every time this component updates,
        //     so every update to HighlightableContent triggers an update in
        //     the child HighlightingUI and SelectionTracker, even if the
        //     behavior hasn't changed.
        //
        //     Over-updating is preferable to under-updating here, because some
        //     updates in this component's props/state *do* affect
        //     `buildHighlight`'s behavior, and *should* trigger an update.
        //
        //     A more performant approach would be to cache this function
        //     object until its implicitly-bound inputs change. If profiling
        //     leads us to implement such caching, this draft might be a good
        //     starting point: https://phabricator.khanacademy.org/D35623?id=170698
        var buildHighlight = function buildHighlight(r) {
            return _this2._buildHighlight(r);
        };

        return React.createElement(
            "div",
            {
                className: css(styles.container),
                ref: function ref(container) {
                    return _this2._container = container;
                }
            },
            React.createElement(
                "div",
                null,
                this.props.enabled && this._container && this._content && React.createElement(HighlightingUI, {
                    buildHighlight: buildHighlight,
                    contentNode: this._content,
                    editable: this.props.editable,
                    highlights: highlights,
                    offsetParent: this._container,
                    zIndexes: {
                        // The content has a z-index of 1, so, to be above
                        // or below the content, use z-index of 2 or 0,
                        // respectively.
                        aboveContent: 2,
                        belowContent: 0
                    },

                    onAddHighlight: this._handleAddHighlight,
                    onRemoveHighlight: this._handleRemoveHighlight
                })
            ),
            React.createElement(
                "div",
                {
                    className: css(styles.content),
                    ref: function ref(content) {
                        return _this2._content = content;
                    }
                },
                React.createElement(
                    WordIndexer,
                    { onWordsUpdate: this._handleWordsUpdate },
                    this.props.children
                )
            )
        );
    };

    return HighlightableContent;
}(React.PureComponent);

HighlightableContent.propTypes = {
    children: require("react").PropTypes.any,
    editable: require("react").PropTypes.bool.isRequired,
    enabled: require("react").PropTypes.bool.isRequired,
    onSerializedHighlightsUpdate: require("react").PropTypes.func.isRequired,
    serializedHighlights: babelPluginFlowReactPropTypes_proptype_SerializedHighlightSet
};


var styles = StyleSheet.create({
    // We render content with z-index 1, and highlights with z-index 0, so that
    // content will receive the browser's native pointer events. (Highlights
    // have their own magic code to manage hover detection, despite being
    // behind the content.)

    container: {
        // Position the container and give it a z-index, to scope the z-indexes
        // inside by creating a stacking context.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        //
        // This way, content's z-index of 1, and highlights' z-index of 0, and
        // tooltips' z-index of 2 don't interact with anything external;
        // external UI will see `HighlightableContent` as a single flat layer
        // with a z-index of 0. This removes the need for us to coordinate our
        // choices of z-index with external UI.
        position: "relative",
        zIndex: 0
    },

    content: {
        // NOTE(mdr): Creating a stacking context for content of z-index 1 may
        //    be problematic if the content and external page want to
        //    interleave layers between each other, e.g., if the application UI
        //    wants to render something above some parts of our content, but
        //    below other parts. It's not relevant for the current Passage-only
        //    call site, but could be relevant someday…
        position: "relative",
        zIndex: 1
    }
});

module.exports = HighlightableContent;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/highlighting/highlightable-content.jsx
 ** module id = 271
 ** module chunks = 0 1
 **/